import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Card, CardMedia, CardContent } from '@mui/material';
import { Height, Label, Padding } from '@mui/icons-material';
import "./addressModal.css";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Grid, TextField } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentsIcon from '@mui/icons-material/Payments';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "50rem",
    height: '40rem',
    bgcolor: 'background.paper',
    border: '',
    boxShadow: 24,
    p: 4,
};

const AddressModal = ({ open, handleClose, handleOpen, addPaymentMethod, paymentMethod, setPaymentMethod }) => {
    
    const handlepaymentOptions = (event) => {
        setPaymentMethod(event.target.value);
    };
    // Form State
    const [nameOnCard, setNameOnCard] = React.useState('');
    const [cardNumber, setCardNumber] = React.useState('');
    const [expires, setExpires] = React.useState('');
    const [cvc, setCVC] = React.useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        const cardEnding = `Card ending with ${cardNumber.slice(-4)}`;
        addPaymentMethod(nameOnCard, "Your Location", cardEnding); // You can customize location as needed

        // Clear the form inputs after submission
        setNameOnCard('');
        setCardNumber('');
        setExpires('');
        setCVC('');
        handleClose()

    };
    return (
        <div>

            <Modal
                open={open}
                className=''
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="ch-address" component='form' onSubmit={handleSubmit}>
                    <Grid container spacing={{ xs: 2, md: 3 }} rowGap={{ xs: 2, sm: 2, md: 2 }}>
                        <Grid container display={"flex"} flexDirection={"column"}>
                            <Grid xs className=' lg:mt-2 ' container justifyContent={"center"}>
                                <Typography variant='body1'>
                                    Payment Method
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid xs={12} className='' >
                            <Card sx={{ maxWidth: 150, boxShadow: 'none' }} className='float-right lg:mr-[0rem] mr-[12rem] '>
                                <CardMedia
                                    component="img"
                                    height="100"
                                    image="https://www.castlexperience.com/modules/webcastle/img/icon-creditcard.png"
                                    alt="Random Image"
                                />
                            </Card>
                        </Grid>

                        <Grid container rowGap={{ xs: 2, sm: 2, md: 2 }} className='lg:mt-[3rem]' >
                        <Grid xs={12} sm={4} md={12} container justifyContent="center">
                                <TextField className='lg:w-[30rem] w-[22rem]' label="Address" />
                            </Grid>
                            <Grid xs={5} sm={4} md={5} container justifyContent="center" className='state ' textAlign={"right"} >
                            <div className='lg:ml-[4.5rem]'>
                                <TextField className='lg:w-[7rem] w-[6rem]' label="State" type='text' />
                            </div>
                            </Grid>
                            <Grid xs={2} sm={4} md={2} container justifyContent="center" textAlign={"center"} >
                                <TextField className='lg:w-[13rem]' label="City" type='text' />
                            </Grid>
                            <Grid xs={5} sm={4} md={5} container justifyContent="center" className='zipcode ' textAlign={"left"}>
                            <div className='lg:mr-[4.5rem]'>
                                <TextField className='lg:w-[7rem] w-[6rem]' label="Zip Code" type='text' />
                            </div>
                            </Grid>
                            <Grid className='' xs={12} sm={12} md={12} container justifyContent="center">
                                <TextField className='lg:w-[30rem] w-[22rem]' value={nameOnCard} onChange={(e) => setNameOnCard(e.target.value)} label="Name on Card" />
                            </Grid>
                            <Grid xs={12} sm={4} md={12} container justifyContent="center">
                                <TextField className='lg:w-[30rem] w-[22rem]' value={cardNumber} onChange={(e) => setCardNumber(e.target.value)} label="Enter Card Number" />
                            </Grid>
                            <Grid xs={7} sm={8} md={6} container justifyContent="center" className='state  lg:align-right' >
                                <div className='lg:ml-[9rem]'>

                                    <label className='mt-3 mr-2 font-bold'>Expiration date: </label>
                                    <select id="month" name="month">
                                        <option value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                    <select id="year" className='ml-2' name="year">
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                        <option value="2027">2027</option>
                                        <option value="2028">2028</option>
                                        <option value="2029">2029</option>
                                        <option value="2030">2030</option>
                                    </select>
                                </div>


                            </Grid>
                            <Grid xs={5} sm={4} md={6} container justifyContent="center" className='' textAlign={"left"}>
                            <div className='lg:mr-[0rem] mr-[11rem]'>

                                <TextField className='lg:w-[7rem] w-[6rem]' value={cvc} onChange={(e) => setCVC(e.target.value)} label="CVC" type='text' />
                            </div>
                            </Grid>
                        </Grid>
                        <Grid container className=' ' justifyContent={"center"} textAlign={"center"}>
                            <Grid >
                                <Button
                                    className="ad-cancel "
                                    onClick={handleClose}
                                    variant=""
                                    type="submit"
                                    sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem", border: 'solid 1px', color: '#1976d2' }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid>
                                <Button
                                    className="ad-continue"
                                    type='submit'
                                    variant=""
                                    sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "10rem", marginLeft: "1rem", border: 'solid 1px', color: '#1976d2' }}
                                >
                                    Add Payment
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>



                    {/* <div onClick={handleClose}>Close</div> */}
                </Box>
            </Modal>
        </div>
    )
}

export default AddressModal